import React, { FunctionComponent, useState, useEffect } from "react";
import LinkSlideLeftProps from "./LinkSlideLeftProps.interface";
import IconViewer from "components/IconViewer/IconViewer";
import styles from "./LinkSlideLeft.module.scss";
import { motion } from "framer-motion";

const LinkSlideLeft: FunctionComponent<LinkSlideLeftProps> = (props) => {
    const [linkActive, setLinkActive] = useState(false);

    const transition = { duration: 0.3 };

    useEffect(() => {
        if (props.clickedLink) {
            setLinkActive(true);
        }
        else {
            setLinkActive(false);
        }
    }, [props.clickedLink]);

    return (
        <motion.div className={styles.link_slide_left} onMouseEnter={() => setLinkActive(true)} onMouseLeave={() => !props.clickedLink && setLinkActive(false)}>
            <motion.div transition={transition} animate={{ x: linkActive ? 0 : 50 }}>
                {props.children}
            </motion.div>
            <motion.div transition={transition} animate={{ opacity: linkActive ? 1 : 0, x: linkActive ? 0 : -10 }}>
                <IconViewer className={styles.button_icon} name="arrow-top-right" aspectRatioX={1} aspectRatioY={1} />
            </motion.div>
        </motion.div>
    );
};

export default LinkSlideLeft;
